import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { ProjectLaunchTarget } from "@custom-types/sdb-company-types";
import { defaultProjectLaunchTargetSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { getOpenProjectHref, getOpenProjectTargetName, OPEN_PROJECT_TARGET_ATTRIBUTE, trackOpenProject } from "@utils/project-utils";
import { HolobuilderIcon, ViewerIcon, Tooltip } from "@flat-ui";
import { useMemo } from "react";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { ACTION_BTN_SIZE, ACTION_ICON_SIZE } from "@styles/common-styles";
/** Renders an icon button to open a project */
export function ProjectOpenButton(t0) {
  const $ = _c(23);
  const {
    project,
    contextType
  } = t0;
  const {
    trackAsyncEvent
  } = useTrackEvent();
  const projectLaunchSettings = useAppSelector(defaultProjectLaunchTargetSelector);
  let t1;
  bb0: {
    if (!projectLaunchSettings.canOpenWebEditor) {
      t1 = "Open project";
      break bb0;
    }
    let t2;
    if ($[0] !== projectLaunchSettings.defaultOpenProjectTarget) {
      t2 = getOpenProjectTargetName(projectLaunchSettings.defaultOpenProjectTarget);
      $[0] = projectLaunchSettings.defaultOpenProjectTarget;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    t1 = `Open project in ${t2}`;
  }
  const openProjectTitle = t1;
  let t2;
  if ($[2] !== contextType || $[3] !== project || $[4] !== projectLaunchSettings.defaultOpenProjectTarget || $[5] !== trackAsyncEvent) {
    t2 = async function onTrackOpenProject(t3) {
      const {
        clickType
      } = t3;
      const numberOfMembers = "members" in project && project.members ? project.members.length : undefined;
      await trackOpenProject({
        openFrom: contextType,
        numberOfMembers,
        openTarget: projectLaunchSettings.defaultOpenProjectTarget,
        clickType,
        ...project,
        trackAsyncEvent
      });
    };
    $[2] = contextType;
    $[3] = project;
    $[4] = projectLaunchSettings.defaultOpenProjectTarget;
    $[5] = trackAsyncEvent;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onTrackOpenProject = t2;
  const t3 = projectLaunchSettings.defaultOpenProjectTarget === ProjectLaunchTarget.sphereViewer ? ViewerIcon : HolobuilderIcon;
  let t4;
  if ($[7] !== project.id || $[8] !== projectLaunchSettings.defaultOpenProjectTarget) {
    t4 = getOpenProjectHref({
      projectId: project.id,
      openTarget: projectLaunchSettings.defaultOpenProjectTarget
    });
    $[7] = project.id;
    $[8] = projectLaunchSettings.defaultOpenProjectTarget;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  let t6;
  let t7;
  if ($[10] !== onTrackOpenProject) {
    t5 = event => {
      event.stopPropagation();
      onTrackOpenProject({
        clickType: "left button click"
      });
    };
    t6 = () => {
      onTrackOpenProject({
        clickType: "middle button click"
      });
    };
    t7 = () => {
      onTrackOpenProject({
        clickType: "open context menu"
      });
    };
    $[10] = onTrackOpenProject;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <SphereIconButton buttonSize={ACTION_BTN_SIZE} iconSize={ACTION_ICON_SIZE} component={t3} href={t4} target={OPEN_PROJECT_TARGET_ATTRIBUTE} onClick={t5} onAuxClick={t6} onContextMenu={t7} />;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== openProjectTitle || $[21] !== t8) {
    t9 = <Tooltip component="div" title={openProjectTitle}>{t8}</Tooltip>;
    $[20] = openProjectTitle;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}